function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export { capitalizeString };
export function extractAttributesWithNullValues(obj) {
  // eslint-disable-next-line no-unused-vars
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
}
